import React, { useRef, useState } from 'react';
import DropZoneBox from 'styles/blocks/photoUpload/dropzone';
import { Error } from 'styles/blocks/error';
import { VALIDATION_MESSAGES } from 'common/validationMessages';

export const DropZone = ({ onAddPhoto, isFileTypeInvalid, isFileMaxSizeExceeded }) => {
  const [highLight, setHighLight] = useState(false);
  const hiddenFileInputRef = useRef();
  const openFileDialog = () => {
    return hiddenFileInputRef.current.click();
  };
  const onDragOver = event => {
    event.preventDefault();
    setHighLight(true);
  };
  const onDrop = event => {
    event.preventDefault();
    const { files } = event.dataTransfer;
    onAddPhoto(files);
    setHighLight(false);
  };
  const onSelectPhoto = event => {
    event.preventDefault();
    onAddPhoto(event.target.files);
    hiddenFileInputRef.current.value = '';
  };
  return (
    <DropZoneBox highLight={highLight} onDragOver={onDragOver} onDragLeave={() => setHighLight(false)} onDrop={onDrop}>
      <DropZoneBox.Text>
        <DropZoneBox.TextLargeScreenOnly>Drag your photos here or use the button below. </DropZoneBox.TextLargeScreenOnly>
        Make sure photos are clear and in focus.
      </DropZoneBox.Text>
      <DropZoneBox.AddPhotosButton onClick={openFileDialog}>Add photos</DropZoneBox.AddPhotosButton>
      <DropZoneBox.HiddenFileInput
        type="file"
        ref={hiddenFileInputRef}
        accept="image/jpeg,.jpg,.jpeg,image/png,.png"
        multiple
        onChange={onSelectPhoto}
        data-automation="photo-upload-input"
      />
      {isFileTypeInvalid && (<Error>{VALIDATION_MESSAGES.PHOTO.FILE_EXTENSION_ERROR}</Error>)}
      {isFileMaxSizeExceeded && (<Error>{VALIDATION_MESSAGES.PHOTO.MAX_SIZE_EXCEEDED}</Error>)}
    </DropZoneBox>
  );
};
